import React, { useEffect, useState } from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery, Box } from "@mui/material";
import { useTheme } from "../style/theme";
import AppsIcon from "@mui/icons-material/Apps";
import { TfiLayoutColumn3 } from "react-icons/tfi";
import { GoCreditCard } from "react-icons/go";
import { BsCollectionPlay } from "react-icons/bs";
import { IoStorefront } from "react-icons/io5";

const BottomNavBar = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");
  const { mode } = useTheme();

  // Define routes that should display the BottomNavBar
  const showBottomNav = [
    "/myStore",
    "/subscription",
    "/subscription/hr/purchase",
    "/subscription/files/purchase",
    "/subscription/E-Sign/purchase",
    "/subscription/Projects/purchase",
    "/payments",
    "/activity",
    "/address",
  ].includes(location.pathname);

  // Update state when route changes
  useEffect(() => {
    const path = location.pathname;
    if (path === "/myStore") setValue(0);
    else if (path.startsWith("/subscription")) setValue(1);
    else if (path === "/activity") setValue(3);
    else if (path === "/payments") setValue(4);
    else setValue(0);
  }, [location.pathname]);

  // Navigation handler
  const handleNavigation = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate("/myStore");
        break;
      case 1:
        navigate("/subscription");
        break;
      case 2:
        window.location.href = "https://worksuite.clikkle.com/products";
        break;
      case 3:
        navigate("/activity");
        break;
      case 4:
        navigate("/payments");
        break;
      default:
        break;
    }
  };

  if (!isMobile || !showBottomNav) {
    return null;
  }

  return (
    <Box>
      <BottomNavigation
        value={value}
        onChange={handleNavigation}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: 65,
          zIndex: 1000,
          backgroundColor: mode === "light" ? "#FFFFFF" : "#141414",
          borderTop: `1px solid ${mode === "light" ? "#E5E7EB" : "#2E2E2E"}`,
          boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.05)",
          display: "flex",
          justifyContent: "space-around",
          "& .MuiBottomNavigationAction-root": {
            minWidth: "auto",
            padding: "6px 0",
            color: mode === "light" ? "#6B7280" : "#A5A5A5",
            "&.Mui-selected": {
              color: "#3B84D9",
            },
          },
        }}
      >
        {[
          {
            label: "Store",
            icon: <IoStorefront  size={22} />,
          },
          { label: "Services", icon: <BsCollectionPlay size={22} /> },
          { label: "Apps", icon: <AppsIcon sx={{ fontSize: 28 }} /> },
          { label: "Activities", icon: <TfiLayoutColumn3 size={20} /> },
          { label: "Payments", icon: <GoCreditCard size={22} /> },
        ].map((item, index) => (
          <BottomNavigationAction
            key={index}
            label={item.label}
            icon={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 32,
                  borderRadius: "16px",
                  backgroundColor: value === index ? (mode === "light" ? "#EBF5FF" : "#3B84D922") : "transparent",
                  mb: 0.5,
                  transition: "background-color 0.2s",
                }}
              >
                {item.icon}
              </Box>
            }
            sx={{
              "& .MuiBottomNavigationAction-label": {
                fontSize: "0.7rem",
                fontWeight: 500,
                "&.Mui-selected": {
                  fontSize: "0.7rem",
                  fontWeight: 600,
                },
              },
            }}
            showLabel
          />
        ))}
      </BottomNavigation>
    </Box>
  );
};

export default BottomNavBar;
